module.exports = __webpack_public_path__ + "img/dormitory2.467a05ce.jpeg";